<div data-automation="number-translation-rules-modal">
  @if (alertHtml) {
    <div class="alert alert-info" [innerHTML]="alertHtml | escapeHtml"></div>
  }
  <div class="d-flex flex-column">
    @for (row of fieldIds; track row.fromFieldId; let i = $index) {
      <div class="d-flex gap-2">
        <div class="col-3">
          <ziro-text [fieldId]="row.fromFieldId"></ziro-text>
        </div>
        <div class="col-3">
          <ziro-text [fieldId]="row.toFieldId"></ziro-text>
        </div>
        <div class="col-4">
          <ziro-text [fieldId]="row.descriptionFieldId"></ziro-text>
        </div>
        <div class="row-add-delete-btn" [ngClass]="{ 'first-row-btn': i === 0 }">
          @if (fieldIds.length === 1 && i === 0) {
            <ziro-button
              [dataAutomation]="'number-translation-rules-add-button-' + i"
              [buttonStyle]="buttonStyles.OUTLINE_SECONDARY"
              [buttonSize]="buttonSize.SMALL"
              [cssClass]="'circle-button'"
              (clicked)="addRow()"
              [isDisabled]="validationState === ValidationState.INVALID"
              [tooltip]="'tkey;number_translation_rules.add.button.disabled.tooltip'"
              [isTooltipDisabled]="validationState === ValidationState.VALID"
              [icon]="ziroIcons.PLUS"
            ></ziro-button>
          } @else {
            <ziro-button
              [dataAutomation]="'number-translation-rules-delete-button-' + i"
              [buttonStyle]="buttonStyles.OUTLINE_SECONDARY"
              [buttonSize]="buttonSize.SMALL"
              [cssClass]="'circle-button'"
              (clicked)="deleteRow(i)"
              [icon]="ziroIcons.MINUS"
            ></ziro-button>
          }
        </div>
        <div class="row-add-delete-btn" [ngClass]="{ 'first-row-btn': i === 0 }">
          @if (i && i === fieldIds.length - 1) {
            <ziro-button
              [dataAutomation]="'number-translation-rules-add-button-' + i"
              [buttonStyle]="buttonStyles.OUTLINE_SECONDARY"
              [buttonSize]="buttonSize.SMALL"
              [cssClass]="'circle-button'"
              (clicked)="addRow()"
              [isDisabled]="validationState === ValidationState.INVALID"
              [tooltip]="'tkey;number_translation_rules.add.button.disabled.tooltip'"
              [isTooltipDisabled]="validationState === ValidationState.VALID"
              [icon]="ziroIcons.PLUS"
            ></ziro-button>
          } @else if (fieldIds.length === 1 && isFirstRowPopulated()) {
            <ziro-button
              dataAutomation="number-translation-rules-clear-button"
              [buttonStyle]="buttonStyles.LINK"
              [buttonSize]="buttonSize.SMALL"
              [label]="'tkey;number_translation_rules.clear.button.label'"
              (clicked)="clearForm()"
            ></ziro-button>
          }
        </div>
      </div>
    }
  </div>

  <ng-template #errorTemplate>
    {{ 'tkey;validators.global.required.missing.error' | translate }}
  </ng-template>
</div>
